module.exports = __webpack_public_path__ + "static/media/marie-rose-win.21251441.png";